"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Sentry = require("@sentry/browser");
exports.onClientEntry = function (_, pluginOptions) {
    var dsn = pluginOptions.dsn;
    if (!dsn)
        return;
    Sentry.init({ dsn: dsn });
};
exports.wrapRootElement = function (_a, pluginOptions) {
    var element = _a.element;
    return (pluginOptions.dsn ?
        React.createElement(SentryBoundary, null, element) :
        element);
};
// https://docs.sentry.io/platforms/javascript/react/
var SentryBoundary = /** @class */ (function (_super) {
    __extends(SentryBoundary, _super);
    function SentryBoundary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SentryBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        Sentry.withScope(function (scope) {
            Object.keys(errorInfo).forEach(function (key) {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
    };
    SentryBoundary.prototype.render = function () {
        return this.props.children;
    };
    return SentryBoundary;
}(React.Component));
